import { LanguageEnum } from "dmsbasereact"

// Force webpack to re-import translations after JSON file updates
export const LOCALES = {
    [LanguageEnum.EN_US]: require("../locales/en_US.json"),
    [LanguageEnum.PT_BR]: require("../locales/pt_BR.json"),
    [LanguageEnum.ES_MX]: require("../locales/es_MX.json")
}
